var map = {
	"./beer-bottle.png": 226,
	"./beer-jar.png": 227,
	"./beer.png": 228,
	"./chicken.png": 229,
	"./coffee.png": 230,
	"./combo.png": 231,
	"./congris.png": 232,
	"./cup.png": 233,
	"./default.png": 130,
	"./donut.png": 234,
	"./drinks.png": 235,
	"./egs.png": 236,
	"./fries.png": 237,
	"./hamburg-yellow.png": 238,
	"./hamburg.png": 239,
	"./hotdog.png": 240,
	"./juice.png": 241,
	"./meal-black.png": 242,
	"./meal-plate.png": 243,
	"./meal.png": 244,
	"./pizza-real.png": 245,
	"./pizza.png": 246,
	"./potatoes.png": 247,
	"./refresh.png": 248,
	"./sandwich-real.png": 249,
	"./sandwich.png": 250,
	"./tea.png": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 225;